import {useTranslation} from "react-i18next";

import {ResponseError as WorkerResponseError} from "../../api/authority/generated/index.ts";
import {ResponseError as AuthorityResponseError} from "../../api/authority/generated/index.ts";

import ApiErrors from "../../../translations/api-errors.json";

let findDefinedApiError = (apiMessage) => {
    return ApiErrors['singular'][apiMessage] ?? ApiErrors['plural'][apiMessage] ?? null;
}

export function useErrorTranslation() {
    const {t} = useTranslation();

    let errorTranslationMethod = (error) => {
        return new Promise(
            (resolve, reject) => {

                if ((typeof error) === 'string') {
                    resolve(error);
                    return;
                }

                if (error instanceof WorkerResponseError || error instanceof AuthorityResponseError) {
                    error.response.json()
                        .then((json) => {
                            let definedApiError = findDefinedApiError(json.message);
                            if (definedApiError === null) {
                                console.warn('UNTRANSLATED STRING');
                                console.warn(json.message);
                                console.warn(json.context);
                                resolve(t('validation.untranslated-error') + ': ' + json.message, json.context);
                            } else {
                                resolve(t(definedApiError, json.context));
                            }
                        })
                        .catch((e) => resolve(t(e.message)));

                    return;
                }

                if (error.message !== undefined && error.context !== undefined) {
                    let definedApiError = findDefinedApiError(error.message);
                    if (definedApiError === null) {
                        console.warn('UNTRANSLATED STRING');
                        console.warn(error.message);
                        console.warn(error.context);
                        resolve(t('validation.untranslated-error') + ': ' + error.message, error.context);
                    } else {
                        resolve(t(definedApiError, error.context));
                    }
                    return;
                }

                console.error('UNABLE TO TRANSLATE ERROR');
                console.error(error);
                resolve(t('validation.unknown-error'));
            }
        );
    };

    return {
        et: errorTranslationMethod,
    };
}
